import React from 'react';
import { getIconForType } from '../../pages/analytics/utils/iconUtils';
import type { AllMetricType } from '../../pages/analytics/types';

type TitleCardProps = {
  title: string;
  type?: AllMetricType;
  icon?: React.ReactNode;
  iconSize?: 'default' | 'small';
  className?: string;
  titleClassName?: string;
  iconClassName?: string;
};

export const TitleCard: React.FC<TitleCardProps> = ({
  title,
  type,
  icon,
  iconSize = 'default',
  className = 'flex gap-3 items-center',
  titleClassName = 'text-xl font-semibold leading-5 text-mainText',
  iconClassName = 'p-0 sm:p-1 xl:p-1 rounded-sm',
}) => {
  const renderIcon = () => {
    if (icon) {
      return icon;
    }
    if (type) {
      try {
        return getIconForType(type, iconSize);
      } catch (error) {
        console.warn('TitleCard: Failed to get icon for type:', type, error);
        return null;
      }
    }
    return null;
  };

  return (
    <div className={className}>
      <div className={iconClassName} style={{ backgroundColor: '#F2F4F5' }}>
        {renderIcon()}
      </div>
      <h2 className={titleClassName}>{title}</h2>
    </div>
  );
};

export default TitleCard;
